module.exports = __webpack_public_path__ + "img/word.21ec94b9.svg";